import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private http: HttpClient
  ) { }

  apiUrl: string = `${environment.HOST}`;

  options: HttpHeaders = new HttpHeaders({
    'Content-Type': 'Aplication/json',
  })

  singIn(username: string, password: string){
    return this.http.post(`${this.apiUrl}/api/auth/signin`, {"email": username, "password": password});
  }

  getUserInfo(username: string){
    return this.http.get(`${this.apiUrl}/api/test/user/${username}`);
  }
}
